export function getAnuncios() {
  let respuesta = fetch(`${process.env.REACT_APP_URL}/anuncios`);
  return respuesta;
}

export function getPublicidad() {
  let respuesta = fetch(`${process.env.REACT_APP_URL}/pub_licidad`);
  return respuesta;
}
